export default [
    
    {
        name: "glbModel",
        type: "glbModel",
        path: "/models/Finish.glb"
    },
    {
        name: "catModel",
        type: "glbModel",
        path: "/models/an_animated_cat.glb"
    },
    {
        name: "textureFloor",
        type: "texture",
        path: "/texture/FloorBake.jpg"
    },
    {
        name: "textureSign",
        type: "texture",
        path: "/texture/FindingWaySign_mtl_Alpha.jpg"
    },
    {
        name: "smokePerlinTexture",
        type: "texture",
        path: "/texture/perlin.png"
    },
    {
        name: "AboutMe1",
        type: "texture",
        path: "/texture/1.png"
    },
    {
        name: "AboutMe2",
        type: "texture",
        path: "/texture/2.png"
    },
    {
        name: "AboutMe3",
        type: "texture",
        path: "/texture/3.png"
    },
    {
        name: "Project1",
        type: "texture",
        path: "/texture/project1.jpg"
    },
    {
        name: "Project2",
        type: "texture",
        path: "/texture/project2.jpg"
    }
    ,
    {
        name: "Project3",
        type: "texture",
        path: "/texture/project3.jpg"
    }
    ,
    {
        name: "Project4",
        type: "texture",
        path: "/texture/project4.jpg"
    }
    ,
    {
        name: "Project5",
        type: "texture",
        path: "/texture/project5.jpg"
    }

    
]